import React from "react";
import { ActiveSession } from "../ActiveSession";
import { AddTask } from "../Task/AddTask";
import { SessionFooter } from "../SessionFooter";
import { TaskList } from "../TaskList";
import { selectSession, useAppState } from "../../state";
import { AtomInputSession } from "../atoms/AtomInputSession";
import { Task } from "../Task/Task";

export const Session = () => {
  const [state, dispatch] = useAppState();
  const session = selectSession(state, state.currentSession);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: "SET_SESSION_NAME",
      payload: { sessionId: session.id, name: e.target.value },
    });
  };

  React.useEffect(() => {
    let totalTime = session.tasks.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.minutes;
    }, 0);
    dispatch({
      type: "SET_SESSION_TIME",
      payload: { sessionId: session.id, time: totalTime },
    });
  }, [dispatch, session.tasks, session.id]);

  const activateSession = React.useCallback(() => {
    dispatch({
      type: "SET_SESSION_ACTIVE",
      payload: { sessionId: session.id, active: true },
    });
    // TODO: start to countdown on the remaining time
    if (session.tasks.length === 0) {
    }
  }, [dispatch, session.id, session.tasks.length]);

  window.addEventListener("keydown", function (event) {
    if (event.metaKey && event.key === "Enter") {
      // do something here
      activateSession();
    }
  });

  const handleMoveTask = (dragIndex: number, hoverIndex: number) => {
    if (dragIndex === hoverIndex) {
      return;
    }

    const tasksCopy = [...session.tasks];
    const draggedTask = tasksCopy[dragIndex];

    tasksCopy.splice(dragIndex, 1);
    tasksCopy.splice(hoverIndex, 0, draggedTask);

    // Update the state with the new order of tasks
    dispatch({
      type: "UPDATE_TASKS_ORDER",
      payload: { sessionId: session.id, tasks: tasksCopy },
    });
  };

  return (
    <div className="relative w-[800px] bg-white px-6 pt-10 pb-8 shadow-md ring-1 ring-gray-800/5 rounded-2xl">
        <>
          <AtomInputSession></AtomInputSession>
          <TaskList tasks={session.tasks} onMoveTask={handleMoveTask} />
          <AddTask/>
          <SessionFooter session={session} />
        </>
    </div>
  );
};

// <input
//   className="font-medium leading-tight text-xl mt-0 mb-2 text-gray-700"
//   type="text"
//   value={session.name}
//   onChange={handleInputChange}
// />
